import { SearchInput } from '@/components/SearchInput';
import { translationVideosSearch } from '@/pages/translation/state';
import { useRecoilState } from 'recoil';

export const Search = () => {
    const [search, setSearch] = useRecoilState(translationVideosSearch);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.currentTarget.value || '';
        setSearch(value);
    };

    const handleSearchClear = () => {
        setSearch('');
    };

    return (
        <SearchInput
            id="video-search-textfield"
            placeholder="Search videos"
            search={search}
            onChange={handleSearchChange}
            onClear={handleSearchClear}
        />
    );
};
